<template>
    <div>
        <br/>There are 4 types of Armor:
        <ul>
            <li><a @click="scrollTo('clothing')" >Clothing</a></li>
            <li><a @click="scrollTo('light')" >Light</a></li>
            <li><a @click="scrollTo('medium')">Medium</a></li>
            <li><a @click="scrollTo('heavy')">Heavy</a></li>
            <li><a @click="scrollTo('shield')">Shields</a></li>                    
        </ul>
        <br/><br/>
        <div v-for="type in types" :key="type">
            <h2 :id="type" style="color:cornflowerblue">{{filterString(type)}}:</h2>            
            <table style="width:100%">
                <tr> 
                    <th>Name</th>
                    <th v-if="!['clothing', 'shield'].includes(type)">Rarity</th>
                    <th>Armor Bonus</th>
                    <th>Max Dex</th>
                    <th>Check Penalty</th>
                    <th>Special</th>
                </tr>
                <tr v-for="armor in sortedArmor(type)" :key="armor.name">
                    <td style="text-align:center; padding-left:4px;padding-right:4px">{{armor.name}}</td>
                    <td style="text-align:center; padding-left:4px;padding-right:4px" v-if="!['clothing', 'shield'].includes(type)">{{armor.rarity}}</td>
                    <td style="padding-left:4px; padding-right:4px">{{armor.armorBonus}}</td>
                    <td style="padding-left:4px; padding-right:4px">{{armor.maxDex}}</td>
                    <td style="padding-left:4px; padding-right:4px">{{armor.armorCheck}}</td>
                    <td style="padding-left:4px; padding-right:4px">{{armor.special}}</td>
                </tr>
            </table>           
            <br/>
        </div>
    </div>
</template>
<script>
//
import {armor} from "../../../play/data"

export default {
  components: {

  },
  props:{
  },
  mounted(){
  },
  data(){
      return{
          types:['clothing','light', 'medium', 'heavy', 'shield'],
      }
  },
  methods:{
      sortedArmor(type){
        let allArmor = [...armor]
        let sortedArmor = allArmor.filter(armor=>armor.type == type)
        let rarities = ['common','rare','epic','legendary','unique']
        let doubleSorted = []
        for(let x = 0; x < 5; x++){
            if(type != "clothing" && type != "shield"){
                let temp = sortedArmor.filter(armor=>armor.rarity == rarities[x])
                temp.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                doubleSorted = doubleSorted.concat(temp)
            }else{
                doubleSorted = sortedArmor.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
            }
            
        }
        return doubleSorted
      },
      scrollTo(id){
        let section = document.getElementById(id)
        section.scrollIntoView({behavior: "smooth"})
      },    
      filterString(str){
          let newStr = str[0].toUpperCase() + str.substring(1)
          if(newStr != "Shield"){
              newStr += " Armor"
          }else{
              newStr += "s"
          }
          return newStr

      },
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>